var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuBtn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "25px",
    viewBox: "0 0 35 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Page 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-300.000000, -257.000000)",
    fill: "#383838"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(300.000000, 257.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    points: "0 4.56190168 34.9247227 4.56190168 34.9247227 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    points: "0 14.4709504 34.9247227 14.4709504 34.9247227 9.90904874 0 9.90904874"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    points: "0 24.3799992 34.9247227 24.3799992 34.9247227 19.8180975 0 19.8180975"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBtn);
export default __webpack_public_path__ + "static/media/menu_btn.965b09fd9c1348b63ace5daae81932b6.svg";
export { ForwardRef as ReactComponent };